import { ApolloLink, Observable, } from "@apollo/client/core";
import { deserializeError } from "serialize-error";
export default class MessengeBusLink extends ApolloLink {
    constructor({ registerResponseHandler, requestHandler }) {
        super();
        this.counter = 0;
        this.observers = new Map();
        this.onResponse = (message) => {
            var _a, _b, _c, _d;
            if (message.type === "ready") {
                (_a = this.readyListener) === null || _a === void 0 ? void 0 : _a.call(this);
                return undefined;
            }
            const { id, type, data } = message.args;
            if (!this.observers.has(id)) {
                return undefined;
            }
            const observer = this.observers.get(id);
            switch (type) {
                case "data":
                    // Data should exist if the type is data
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (_b = observer === null || observer === void 0 ? void 0 : observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, data);
                case "error": {
                    this.observers.delete(id);
                    return (_c = observer === null || observer === void 0 ? void 0 : observer.error) === null || _c === void 0 ? void 0 : _c.call(observer, deserializeError(data));
                }
                case "complete": {
                    this.observers.delete(id);
                    return (_d = observer === null || observer === void 0 ? void 0 : observer.complete) === null || _d === void 0 ? void 0 : _d.call(observer);
                }
            }
            return undefined;
        };
        this.postMessage = requestHandler;
        registerResponseHandler(this.onResponse);
    }
    request(operation) {
        return new Observable((observer) => {
            this.counter += 1;
            const current = `${this.counter}`;
            const request = {
                operationName: operation.operationName,
                variables: operation.variables,
                query: operation.query,
            };
            this.observers.set(current, observer);
            this.postMessage({ type: "request", args: { id: current, request } });
        });
    }
    /**
     * Initialise the backend with the provided args.
     * Will resolve once the backend has been created,
     * and has responded with ready.
     *
     * This doesn't need to be called if you preinitialise
     * the backend (in electron main for example)
     */
    async initialiseBackend(args) {
        const readyResponse = new Promise((resolve) => {
            this.readyListener = () => {
                this.readyListener = undefined;
                resolve();
            };
        });
        this.postMessage({ type: "init", args });
        await readyResponse;
    }
}
//# sourceMappingURL=BusLink.js.map